import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus-solid",
  "use": "minus-solid-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"minus-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M11 0a11 11 0 1011 11A11 11 0 0011 0zm4 12H7a1 1 0 010-2h8a1 1 0 010 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol